export const APP_URI_FAILURE = 'APP_URI_FAILURE';
export const APP_URI_SUCCESS = 'APP_URI_SUCCESS';
export const FETCH_APP_URI = 'FETCH_APP_URI';
export const VERIFY_EMAIL_ATTEMPT = 'VERIFY_EMAIL_ATTEMPT';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const CLEAR_STATE = 'CLEAR_STATE';
